"use client";

import { PrimaryButton } from "ui/components";
import { ArrowRightIcon } from "ui/iconsN";

export const ScrollButton = () => {
  return (
    <a
      href="https://www.welcometothejungle.com/fr/companies/intermedes/jobs/guide-conferencier_paris"
      target="_blank"
      rel="noreferrer"
    >
      <PrimaryButton>
        Voir nos offres
        <ArrowRightIcon />
      </PrimaryButton>
    </a>
  );
};
